module.exports = __webpack_public_path__ + "img/zaisu_large.8938c6f2.jpg";